<!-- An index is displayed for numeration of team members and invitations. 
  Applicants do not count towards the member limit, thus they don't get an index. -->
<div class="next__user-index">
  <span
    *ngIf="index && (user?.membershipStatus === TeamMembershipStatus.MEMBER || user?.membershipStatus === TeamMembershipStatus.INVITATION)"
  >
    {{ index }}
  </span>
</div>

<!-- Chip with membership status of user. 
  If currently logged in user is not the founder, user role is displayed in the back -->
<div
  [ngClass]="{
    'next__user-role-container': true,
    'next__user-role-container--back': loggedInUser?.isFounder
  }"
>
  <p *ngIf="user?.isFounder" class="next__user-role next__user-role--founder">
    {{ 'STATS.CHALLENGE_NEXT.membershipStatus.founder' | translate }}
  </p>
  <p *ngIf="user?.membershipStatus === TeamMembershipStatus.MEMBER && !user?.isFounder" class="next__user-role next__user-role--member">
    {{ 'STATS.CHALLENGE_NEXT.membershipStatus.member' | translate }}
  </p>

  <p *ngIf="user?.membershipStatus === TeamMembershipStatus.INVITATION" class="next__user-role next__user-role--invitation">
    {{ 'STATS.CHALLENGE_NEXT.membershipStatus.invitationPending' | translate }}
  </p>

  <p *ngIf="user?.membershipStatus === TeamMembershipStatus.APPLICATION" class="next__user-role next__user-role--application">
    {{ 'STATS.CHALLENGE_NEXT.membershipStatus.applicationPending' | translate }}
  </p>
</div>

<!-- Name of the user -->
<div class="next__user-name" [ngClass]="{ 'next__user-name--nonMember': user?.membershipStatus !== TeamMembershipStatus.MEMBER }">
  <!-- If the user has a userID, that means he must be registered, thus we should show the email at hover tooltip-->
  <span title="{{ loggedInUser?.membershipStatus === TeamMembershipStatus.MEMBER && user?._id ? user?.email : null }}">
    <!-- Display alias of user -->
    <span *ngIf="user?.alias">
      {{ user.alias }}
    </span>
    <!-- If no alias is set, display firstName and lastName -->
    <span *ngIf="!user?.alias && user?.firstName">{{ user?.firstName + ' ' + user?.lastName }}</span>
    <!-- For newly invited users which are not registered yet, we can only display email. The email should only be seen by team members. -->
    <span *ngIf="!user?.alias && !user?.firstName">
      {{ loggedInUser.membershipStatus === TeamMembershipStatus.APPLICATION ? ('STATS.noName' | translate) : user?.email }}</span
    >
  </span>
  <img
    *ngIf="loggedInUser?._id === user?._id"
    src="assets/icons/general/person.svg"
    title="{{ loggedInUser._id === user._id ? ('CHALLENGE.thatsMe' | translate) : null }}"
    class="next__user-name-user-icon"
  />
</div>

<!-- Actions available for team founder -->
<div *ngIf="loggedInUser?.isFounder" class="next__user-action-container">
  <ng-container *ngIf="user?.membershipStatus === TeamMembershipStatus.MEMBER && !user?.isFounder">
    <!-- Remove team member (Has to be confirmed) -->
    <span *ngIf="!confirmMode" class="next__user-action next__user-action--remove" (click)="displayConfirmMode()">
      <img src="assets/icons/general/delete.svg" class="next__icon" />
      {{ 'STATS.CHALLENGE_NEXT.actions.remove' | translate }}
    </span>
    <!-- Confirmation mode -->
    <span *ngIf="confirmMode" class="next__user-action-confirm-text">
      {{ 'STATS.CHALLENGE_NEXT.actions.confirmRemoval' | translate }}
    </span>
    <span
      *ngIf="confirmMode"
      class="next__user-action next__user-action--secondary next__user-action--cancelConfirmation"
      (click)="cancelConfirmMode()"
    >
      {{ 'STATS.CHALLENGE_NEXT.actions.keep' | translate }}
    </span>
    <span *ngIf="confirmMode" class="next__user-action next__user-action--remove" (click)="removeUser()">
      <img src="assets/icons/general/delete.svg" class="next__icon" />
      {{ 'STATS.CHALLENGE_NEXT.actions.remove' | translate }}
    </span>
  </ng-container>

  <ng-container *ngIf="user?.membershipStatus === TeamMembershipStatus.INVITATION">
    <!-- Cancel invitation (Has to be confirmed) -->
    <span *ngIf="!confirmMode" class="next__user-action next__user-action--cancel" (click)="displayConfirmMode()">
      <img src="assets/icons/general/cancel.svg" class="next__icon" />
      {{ 'STATS.CHALLENGE_NEXT.actions.cancel' | translate }}
    </span>

    <!-- Confirmation mode -->
    <span *ngIf="confirmMode" class="next__user-action-confirm-text">
      {{ 'STATS.CHALLENGE_NEXT.actions.confirmCancelInvitation' | translate }}
    </span>
    <span
      *ngIf="confirmMode"
      class="next__user-action next__user-action--secondary next__user-action--cancelConfirmation"
      (click)="cancelConfirmMode()"
    >
      {{ 'STATS.CHALLENGE_NEXT.actions.keep' | translate }}
    </span>
    <span *ngIf="confirmMode" class="next__user-action next__user-action--cancel" (click)="cancelInvitation()">
      <img src="assets/icons/general/cancel.svg" class="next__icon" />
      {{ 'STATS.CHALLENGE_NEXT.actions.cancel' | translate }}
    </span>
  </ng-container>

  <ng-container *ngIf="user?.membershipStatus === TeamMembershipStatus.APPLICATION">
    <!-- Team has no slots left -->
    <p
      *ngIf="team?.userGroups.invitations.length + team?.userGroups.members.length >= challenge?.maximumTeamMembers"
      class="next__user-no-slots"
    >
      {{ 'STATS.CHALLENGE_NEXT.noSlots' | translate }}
    </p>

    <!-- Team has slots left -->
    <ng-container *ngIf="team?.userGroups.invitations.length + team?.userGroups.members.length < challenge?.maximumTeamMembers">
      <!-- Accept does not have to be confirmed -->
      <span *ngIf="!confirmMode" class="next__user-action next__user-action--accept" (click)="acceptApplication()">
        <img src="assets/icons/general/accept.svg" class="next__icon" />
        {{ 'STATS.CHALLENGE_NEXT.actions.accept' | translate }}
      </span>

      <!-- Cancel application has to be confirmed -->
      <span *ngIf="!confirmMode" class="next__user-action next__user-action--decline" (click)="displayConfirmMode()">
        <img src="assets/icons/general/decline.svg" class="next__icon" />
        {{ 'STATS.CHALLENGE_NEXT.actions.decline' | translate }}
      </span>

      <!-- Confirmation mode -->
      <span *ngIf="confirmMode" class="next__user-action-confirm-text">
        {{ 'STATS.CHALLENGE_NEXT.actions.confirmDeclineApplication' | translate }}
      </span>
      <span
        *ngIf="confirmMode"
        class="next__user-action next__user-action--secondary next__user-action--cancelConfirmation"
        (click)="cancelConfirmMode()"
      >
        {{ 'STATS.CHALLENGE_NEXT.actions.keep' | translate }}
      </span>
      <span *ngIf="confirmMode" class="next__user-action next__user-action--decline" (click)="declineApplication()">
        <img src="assets/icons/general/decline.svg" class="next__icon" />
        {{ 'STATS.CHALLENGE_NEXT.actions.decline' | translate }}
      </span>
    </ng-container>
  </ng-container>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/components/next-challenge-user/next-challenge-user.component.html